import React, { useEffect } from "react";
import ReactLoading from "react-loading";
import Footer from "../../../components/footer";
import Breadcrumb from "../../../components/breadcrumb";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import PlantelesHeader from "../components/PlantelesHeader";
import PlantelesList from "../components/PlantelesList";
import PlantelesPagination from "../components/PlantelesPagination";
import usePlantelesData from "../hooks/usePlantelesData";

function Planteles() {
    const {
        isLoading,
        isError,
        search,
        setSearch,
        onlyChampions,
        setOnlyChampions,
        currentPage,
        setCurrentPage,
        totalPages,
        totalPlanteles,
        pagedPlanteles,
    } = usePlantelesData();


    useEffect(() => {
        document.title = 'Planteles';
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-3 sm:px-4 md:px-10 pt-2 pb-6 sm:pb-8 md:pb-10">
                <Breadcrumb
                    items={[
                        { label: 'Inicio', to: '/' },
                        { label: 'Planteles', isCurrent: true },
                    ]}
                    className="mb-3 sm:mb-4"
                />

                <PlantelesHeader
                    search={search}
                    onSearchChange={setSearch}
                    onlyChampions={onlyChampions}
                    onToggleChampions={() => setOnlyChampions((value) => !value)}
                />

                {isLoading && (
                    <div className="rounded-xl border border-white/10 bg-[#102216] p-6 sm:p-10">
                        <ReactLoading type="bars" color="#22c55e" width={60} className="text-center m-auto mb-6 sm:mb-10 sm:[&>div]:!w-[80px]" />
                        <p className="text-center text-slate-200 text-base sm:text-lg font-semibold">Cargando planteles...</p>
                    </div>
                )}

                {isError && !isLoading && (
                    <div className="rounded-xl border border-red-400/30 bg-red-950/20 p-6 sm:p-8 text-center text-red-200 text-sm sm:text-base font-medium">
                        No se pudieron cargar los planteles en este momento.
                    </div>
                )}

                {!isLoading && !isError && (
                    <>
                        <PlantelesList planteles={pagedPlanteles} />

                        <PlantelesPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <p className="text-center text-slate-500 text-xs sm:text-sm font-medium mt-3 sm:mt-4">
                            Mostrando {pagedPlanteles.length} de {totalPlanteles} planteles
                            (página {currentPage} de {totalPages}).
                        </p>

                    </>
                )}
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Planteles;
